import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-membership-search-criteria',
    templateUrl: './membership-search-criteria.component.html',
    styleUrls: ['./membership-search-criteria.component.scss'],
    standalone: false
})
export class MembershipSearchCriteriaComponent implements OnInit {
    @Input() public searchForm: UntypedFormGroup;

    constructor() {}

    ngOnInit() {}

    showExpressionClear() {
        return this.searchForm.controls['expression'].value;
    }

    onExpressionClear() {
        this.searchForm.controls['expression'].setValue(null);
    }
}
